import { useState,useRef } from 'react'

import './button.scss'

type ExplorerPorps = {
  title?: string
  icon?: any
  click: () => void
  size?: 'small'
  style?: any,
  activeInactive?: boolean
  disabled?: boolean,
  dropdown?: Array<{ title: string, onClick: () => void }>
  dropdownPosition?: 'bottomLeft' | 'leftEdge' | 'fullWidth' | 'rightEdge'
  dropdownSize?: 'large'
}

function Button(props: Readonly<ExplorerPorps>) {
  const catMenu = useRef<HTMLDivElement  | null>(null)
  const [dropdown, setDropdown] = useState(false)
  const [dropdownPosition, setDropdownPosition] = useState({ top: '0px', left: '0px', right: 'auto' })

  const closeOpenMenus = (e: any)=>{
    if(dropdown && !catMenu.current?.contains(e.target)){
      setDropdown(false)
    }
  }

  const calculatePosition = () => {
    if (catMenu.current) {
      const rect = catMenu.current.getBoundingClientRect()
      if (props.dropdownPosition === 'bottomLeft') {
        setDropdownPosition({
          top: `${rect.bottom + 2}px`,
          left: 'auto',
          right: `${window.innerWidth - rect.right}px`
        })
      } else if (props.dropdownPosition === 'leftEdge') {
        setDropdownPosition({
          top: `${rect.bottom + 2}px`,
          left: '0px',
          right: 'auto'
        })
      } else if (props.dropdownPosition === 'fullWidth') {
        const topNav = catMenu.current.closest('.comp-topNav')
        const topNavRect = topNav?.getBoundingClientRect()
        setDropdownPosition({
          top: topNavRect ? `${topNavRect.bottom}px` : `${rect.bottom}px`,
          left: '0px',
          right: '0px'
        })
      } else if (props.dropdownPosition === 'rightEdge') {
        const tapBar = catMenu.current.closest('.comp-tapBar')
        const tapBarRect = tapBar?.getBoundingClientRect()
        setDropdownPosition({
          top: tapBarRect ? `${tapBarRect.bottom}px` : `${rect.bottom + 2}px`,
          left: 'auto',
          right: '0px'
        })
      } else {
        setDropdownPosition({
          top: `${rect.bottom + 2}px`,
          left: `${rect.left}px`,
          right: 'auto'
        })
      }
    }
  }

  if(props.dropdown) {
    document.addEventListener('mousedown',closeOpenMenus)
    return (
      <div ref={catMenu} style={{ position: 'relative' }}>
        {props.icon ? (
          <button
            style={props.style}
            className={`button-icon${props.size ?  '-' + props.size : null}`}
            onClick={(e) => {e.stopPropagation(); calculatePosition(); setDropdown(!dropdown)}}
            disabled={props.disabled}>
            {props.icon}
          </button>
        ) : (
          <button
            className={`${props.size ? 'button-' + props.size : ''}`}
            style={props.style}
            onClick={(e) => {e.stopPropagation(); calculatePosition(); setDropdown(!dropdown)}}
            disabled={props.disabled}
          >
            {props.title}
          </button>
        )}

        {dropdown && <div className={`dropdown ${props.dropdownSize === 'large' ? 'dropdown-large' : ''} ${props.dropdownPosition === 'fullWidth' ? 'dropdown-fullWidth' : ''}`} style={{ top: dropdownPosition.top, left: dropdownPosition.left, right: dropdownPosition.right }}>

          {props.dropdown.map((link) => {
            return (
            <button 
              key={link.title}
              onClick={() => {
                link.onClick()
                setDropdown(false)
              }} 
              className='dropdown-link'
            >
              {link.title}
            </button>
          )
          })}

        </div>}
      </div>
    )
  }

  if(props.activeInactive !== undefined) {
    return (
      <button
        className={`activeInactive ${props.size ? 'button-' + props.size : ''} ${props.activeInactive ? 'activeInactiveActive' : ''}`}
        style={props.style}
        onClick={(e) => {e.stopPropagation(); props.click()}}
        disabled={props.disabled}
      >
        {props.title}
      </button>
    )
  }

  if(props.icon) {
    return (
      <button style={props.style} className={`button-icon${props.size ?  '-' + props.size : null}`} onClick={(e) => {e.stopPropagation(); props.click()}} disabled={props.disabled}>
        {props.icon}
      </button>
    )
  }

  return (
    <button
      className={`${props.size ? 'button-' + props.size : ''}`}
      style={props.style}
      onClick={(e) => {e.stopPropagation(); props.click()}}
      disabled={props.disabled}
    >
      {props.title}
    </button>
  )
}

export default Button
